var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs'),(_vm.showTabs)?_c('Tabs'):_vm._e(),(!_vm.showTabs)?_c('div',{staticClass:"noMenu"},[_vm._v("Acesse um item do menu")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }